export default __webpack_public_path__ + "media/images/topright-onglet-767151d443db2fff6c7f4e46e6a76fab.png";